import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

export type FeatureEnum =
  | 'MultipleShowings'
  | 'WelcomePageLogo'
  | 'WelcomePageBackground'
  | 'WelcomeCustomPage'
  | 'EndCustomPages'
  | 'EndFeedbackLink'
  | 'EndSubscribeLink'
  | 'EndDonationLink'
  | 'UnlimitedSessions'
  | 'UnlimitedAttendees';

type FeatureGateProps = {
  feature?: FeatureEnum;
  anyFeature?: FeatureEnum[];
  fallback?: ReactNode;
  children: ReactNode;
};

export const FeatureGate: React.FC<FeatureGateProps> = ({
  feature,
  anyFeature,
  fallback = null,
  children
}) => {
  const { features } = useAuth();

  if (feature && features.includes(feature)) {
    return <>{children}</>;
  }

  if (anyFeature && anyFeature.some((f) => features.includes(f))) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
